export default "__VITE_ASSET__DRvv8Zcm__"